import { render, staticRenderFns } from "./GuessLike.vue?vue&type=template&id=43ff6b50&scoped=true"
import script from "./GuessLike.vue?vue&type=script&lang=js"
export * from "./GuessLike.vue?vue&type=script&lang=js"
import style0 from "./GuessLike.vue?vue&type=style&index=0&id=43ff6b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff6b50",
  null
  
)

export default component.exports